import React from 'react';

class RouteTitle extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      title: this.props.title === undefined ? '' : this.props.title,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillMount(){
    document.title = this.state.title;
  }

  render( ) {
    if( this.state.hasError === false ) {
      return (
        <span style={{'display':'none'}}></span>
      );
    } else {
      return (
        <span></span>
      );
    }
  }
}

export default RouteTitle;



// WEBPACK FOOTER //
// ./src/presentation/RouteTitle.js